// eslint-disable-next-line import/prefer-default-export
export const MINIMUM_PASSWORD_CHAR_LENGTH = 6;

